import { useEffect, useId, useState } from 'react'
import { POSITIONS_TAB_COPY, signalCellOpacity } from '../trade/positionsEmpty'

function openConnect() {
  window.dispatchEvent(new Event('lighter:open-connect'))
}

export default function PositionsEmpty({ connected, tab }) {
  const patternId = useId().replace(/:/g, '')
  const copy = POSITIONS_TAB_COPY[tab] || POSITIONS_TAB_COPY.Positions
  const [cells, setCells] = useState([])

  useEffect(() => {
    if (connected) return undefined
    const started = performance.now()
    const period = 2600
    let raf = 0
    const tick = (now) => {
      const cycle = ((now - started) % period) / period
      const ping = cycle < 0.5 ? cycle * 2 : 2 - cycle * 2
      const t = ping * ping * (3 - 2 * ping)
      const next = []
      for (let col = 0; col < 11; col += 1) {
        for (let row = 0; row < 11; row += 1) {
          const op = signalCellOpacity(col, row, t)
          if (!op) continue
          next.push({
            key: `${col}-${row}`,
            x: 0.65 + col * 4,
            y: 0.65 + row * 4,
            op,
          })
        }
      }
      setCells(next)
      raf = requestAnimationFrame(tick)
    }
    raf = requestAnimationFrame(tick)
    return () => cancelAnimationFrame(raf)
  }, [connected])

  if (connected) {
    return (
      <div
        role="status"
        className="flex flex-col items-center justify-center gap-3 py-14 text-center max-mobile:justify-start max-mobile:py-8 max-mobile:flex-1 max-mobile:px-6"
        data-testid="positions-empty"
      >
        <p className="max-w-[320px] text-sm/sm text-pretty text-dim">{copy.empty}</p>
      </div>
    )
  }

  return (
    <div
      role="status"
      className="flex flex-col items-center justify-center gap-3 py-14 text-center max-mobile:justify-start max-mobile:py-8 max-mobile:flex-1 max-mobile:px-6"
      data-testid="positions-disconnected"
    >
      <span className="inline-flex" aria-hidden="true">
        <svg viewBox="0 0 44 44" className="size-14 overflow-visible">
          <defs>
            <pattern
              id={patternId}
              width="4"
              height="4"
              patternUnits="userSpaceOnUse"
            >
              <rect
                x="0.65"
                y="0.65"
                width="2.7"
                height="2.7"
                fill="currentColor"
                fillOpacity="0.09"
              />
            </pattern>
          </defs>
          <rect width="44" height="44" fill={`url(#${patternId})`} className="text-ink" />
          <g data-positions-signal-bars>
            {cells.map((cell) => (
              <rect
                key={cell.key}
                x={cell.x}
                y={cell.y}
                width="2.7"
                height="2.7"
                fill="currentColor"
                fillOpacity={cell.op}
              />
            ))}
          </g>
        </svg>
      </span>
      <span className="font-mono label-meta text-md/md text-ink">Not connected</span>
      <p className="max-w-[320px] text-sm/sm text-pretty text-dim">
        Connect a wallet to see your {copy.noun}.
      </p>
      <button
        type="button"
        onClick={openConnect}
        className="inline-flex cursor-pointer items-center gap-2 py-0.5 text-sm/sm font-medium text-meta underline underline-offset-2 hover:text-ink active:text-meta disabled:opacity-50 disabled:no-underline"
      >
        <span>Connect Wallet</span>
      </button>
    </div>
  )
}
